<template>
    <div class="file-wrapper-multi-view-info">
        <span class="file-wrapper-multi-view-info__pn">
            {{ patentHeaderInfo.pn }}
        </span>
        <Legal
            class="file-wrapper-multi-view-info__legal"
            :legalObject="patentHeaderInfo.legalObject"
            :legalStatus="patentHeaderInfo.legalStatus"
        />
        <p class="file-wrapper-multi-view-info__title" :title="patentHeaderInfo.title" v-html="patentHeaderInfo.title || $t('no-title')" />
    </div>
</template>

<script setup lang="ts">
import Legal from '@/components/legal';
import useFileWrapperMultiView from '../../composables/use-file-wrapper-multi-view';

const { patentHeaderInfo } = useFileWrapperMultiView();

</script>


<style lang="scss">
.file-wrapper-multi-view-info {
    display: flex;
    height: 32px;
    padding: 0 16px;
    align-items: center;
    line-height: 24px;
    overflow: hidden;
    .file-wrapper-multi-view-info__pn {
        color: $brand-hover;
        margin-right: 4px;
    }

    .file-wrapper-multi-view-info__legal {
        display: flex;
        align-items: center;
        margin-right: 8px;
        & > .legal-tag {
            margin-right: 8px;
        }
        .legal-status__box .patsnap-biz-icon {
            margin-top: 0;
        }
    }

    .file-wrapper-multi-view-info__title {
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
    }
}

</style>
